/**
 * マスタ変更履歴の閲覧に必要な機能キー (マスタ変更履歴 SBI 7)。
 *
 * 「元のマスタ画面と同じ機能」を持つ人だけがその履歴を見られる。
 * 機能キー `master_history` はヘッダーナビのタブの表示だけを制御し、閲覧権限には使わない
 * (通知メールのリンクや各マスタ画面の導線から入る人を、このキーで締め出さないため)。
 * 正本は `lambda/common/permission_features.py` の `MASTER_HISTORY_FEATURE_BY_TYPE`。
 * ここは画面の出し分け用の写しで、`masterHistoryFeatures.test.ts` が一致を検証する。
 *
 * ⚠️ 画面の出し分けは利便性のため。最終的な拒否は常にバックエンドの 403。
 */
import type { MasterHistoryType } from '../api/types';

export const MASTER_HISTORY_FEATURE_BY_TYPE: Readonly<Record<MasterHistoryType, string>> = {
  broadcast_spot: 'broadcast_points',
  chime: 'chimes',
  phrase_template: 'phrase_templates',
  ssml_dictionary: 'ssml_dictionary',
  free_text_template: 'free_text_templates',
  permission_group: 'permission_group_admin',
  device: 'devices',
};

/** 履歴画面のルートを通す機能キー (履歴を持つマスタの機能のいずれか。重複なし) */
export const MASTER_HISTORY_FEATURE_KEYS: readonly string[] = Array.from(
  new Set(Object.values(MASTER_HISTORY_FEATURE_BY_TYPE)),
);
